import { LinearProgressProps, Box, LinearProgress, useTheme } from '@mui/material'
import React from 'react'

type Props = LinearProgressProps & {
    round1?: number
    round2?: number
    round3?: number
    finalRound?: number
}

const RoundProgress = ({
    value,
    relativeSpace = '25%',
}: {
    value: number
    relativeSpace?: string
}) =>  {
    const muiTheme = useTheme()
    return (
        <Box sx={{ width: relativeSpace, mr: 1 }}>
            <Box
                sx={{
                    position: 'relative',
                    zIndex: 1,
                    bottom: -15,
                    width: relativeSpace,
                    height: '25',
                    display: 'flex',
                    flex: 1,
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            ></Box>
            <LinearProgress
                variant="determinate"
                className="h-4 border border-solid border-gray-500 rounded-sm"
                style={{
                    backgroundColor: muiTheme.palette.background.paper,
                }}
                value={value}
            />
            <Box sx={{ minWidth: 35 }}>
          </Box>
        </Box>
    )
}

export const RoundsProgress = (p: Props) => {
    const {
        className,
        sx,
        round1 = 100,
        round2 = 50,
        round3 = 0,
        finalRound = 0,
        ...rest
    } = p

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                ...sx,
            }}
        >
            <RoundProgress value={round1} />
            <RoundProgress value={round2} />
            <RoundProgress value={round3} />
            <RoundProgress value={finalRound} relativeSpace="10%" />
        </Box>
    )
}
